export default __webpack_public_path__ + "static/yoga-9-8729076d89317acbd51abe7de2067a98.png";